export enum ColorConfigKeys {
  NEW_ORDERS = 'accepted',
  IN_PRODUCTION = 'inPreparation',
  ON_DELIVERY = 'onTheWay',
}
